import { FC, useEffect, useState } from 'react'
import { useSelector } from "react-redux"
import * as prismic from '@prismicio/client'
import { PrismicRichText } from '@prismicio/react'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import selectCmsCtx from 'redux/selectors/selectCmsCtx'
import { CMSCtx } from "interfaces/cms"
import { SERVICE_UNAVAILABLE_BANNER_DOCUMENT_ID } from 'constants/cms'

const ServiceUnavailableBanner: FC = () => {
  const cmsCtx: CMSCtx = useSelector(selectCmsCtx)
  const [bannerText, setBannerText] = useState()
  const fetchBanner = async () => {
    try {
      const response = await cmsCtx.api.getSingle(SERVICE_UNAVAILABLE_BANNER_DOCUMENT_ID,
        {
          predicates: [
            prismic.predicate.at(`my.${SERVICE_UNAVAILABLE_BANNER_DOCUMENT_ID}.visible`, true)
          ]
        }
      )
      setBannerText(response.data.banner_text)
    } catch (e) {
      console.log('service_unavailability_banner error', e)
    }
  }
  const handleClose = () => {
    setBannerText(undefined)
  }
  useEffect(() => {
    if (cmsCtx) {
      fetchBanner()
    }
  }, [cmsCtx])
  return (bannerText ?
    (<div className='w-80 w-90-m fixed z1055 top5 left-50 bg-black white ph6 fs x--50 tc'>
      <IconButton
        size='small'
        aria-label='close'
        className='absolute right0 pa4 white'
        onClick={handleClose}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
      <PrismicRichText field={bannerText} />
    </div>)
    : null)
}
export default ServiceUnavailableBanner